module.exports = "/_next/static/images/32782896a1d7e7c4f3447f3025e74262-app-screenshots-lg@1x.jpg.webp";